import React, { Component } from "react";

import { Card } from "components/Card/Card.jsx";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Table,
  Modal,
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import { thArray, tdArray } from "variables/Variables.jsx";
import { connect } from "react-redux";
import {
  addNewAddress,
  removeCustomerAddress,
  selectCustomer,
} from "../../redux/actions";
import { NotificationManager } from "react-notifications";
import { PersianNumber } from "@thg303/react-persian";
import copy from "copy-to-clipboard";

const mapStateToProps = (state) => {
  return {
    customerAddresses: state.selectedCustomer.addresses,
    selectedCustomer: state.selectedCustomer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addNewAddress: (customer, address) =>
      dispatch(addNewAddress(customer, address)),
    removeAddressRedux: (customer, address) =>
      dispatch(removeCustomerAddress(customer, address)),
    selectCustomer: (customer) => {
      dispatch(selectCustomer(customer));
    },
  };
};

class AddNewAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      show: false,
      selectedAddress: {
        address: "",
        id: "",
      },
    };
    this.changeAddress = this.changeAddress.bind(this);
    this.addNewAddressBtn = this.addNewAddressBtn.bind(this);
    this.removeAddress = this.removeAddress.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleHide() {
    this.setState({ show: false });
    this.setState({ selectedAddress: { address: "", id: "" } });
  }

  handleRemove() {
    this.props.removeAddressRedux(
      this.props.selectedCustomer,
      this.state.selectedAddress
    );
    NotificationManager.success("انجام شد", "آدرس با موفقیت حذف شد");
    this.handleHide();
  }

  removeAddress(prop) {
    this.setState({ selectedAddress: prop });
    this.setState({ show: true });
  }

  changeAddress(e) {
    this.setState({ address: e.target.value });
  }

  addNewAddressBtn(e) {
    e.preventDefault();
    const newAddress = {
      address: this.state.address,
      id: this.props.customerAddresses.length + 1,
    };
    console.log(newAddress);
    window.server.emit(
      "add_address",
      this.props.selectedCustomer._id,
      newAddress,
      (data) => {
        if (data.code == 200) {
          this.setState({ address: "" });
          this.address.value = "";
          this.props.selectCustomer(JSON.parse(data.response));
          NotificationManager.success("آدرس جدید افزوده شد", "انجام شد");
        } else {
          NotificationManager.success("مشکلی در ثبت آدرس", "خطا");
        }
      }
    );
  }

  componentWillMount() {
    console.log("this is log component");
  }

  render() {
    return (
      <Row>
        <Col md={12}>
          <Card
            title="آدرس‌ها"
            content={
              <div>
                <form>
                  <Row>
                    <Col xs={12}>
                      <FormGroup>
                        <ControlLabel>آدرس جدید</ControlLabel>
                        <FormControl
                          type="text"
                          // value={this.state.customer.lastName}
                          bsClass="form-control"
                          placeholder="آدرس جدید"
                          inputRef={(ref) => {
                            this.address = ref;
                          }}
                          defaultValue={this.state.address}
                          onChange={this.changeAddress}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button
                    bsStyle="info"
                    onClick={this.addNewAddressBtn}
                    pullRight
                    fill
                    type="submit"
                  >
                    اضافه کردن
                  </Button>
                  <div className="clearfix" />
                  <hr />
                </form>
                <Table striped hover>
                  <thead>
                    <tr>
                      <th className="text-right">شماره</th>
                      <th className="text-right">آدرس</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.customerAddresses.map((prop, key) => {
                      return (
                        <tr
                          style={{ cursor: "pointer" }}
                          key={key}
                          onClick={() => this.removeAddress(prop)}
                        >
                          <td>
                            <PersianNumber>{key + 1}</PersianNumber>
                          </td>
                          <td>{prop.address}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            }
          />
        </Col>

        <Modal
          show={this.state.show}
          onHide={this.handleHide}
          container={this}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">حذف آدرس</Modal.Title>
          </Modal.Header>
          <Modal.Body>آیا میخواهید آدرس انتخابی را حذف کنید ؟</Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleHide}>بستن</Button>
            {document.queryCommandSupported("copy") && (
              <Button
                bsStyle="success"
                onClick={() => {
                  copy(this.state.selectedAddress.address);
                }}
              >
                رونوشت
              </Button>
            )}
            <Button bsStyle="danger" onClick={this.handleRemove}>
              حذف آدرس
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
    );
  }
}

const AddNewAddressConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddNewAddress);

export default AddNewAddressConnect;
